import React from 'react';
import Student_form_content from './Student_form_content'
import Student_Form from './Student_Form'
import { Helmet } from 'react-helmet-async';

function Student_Register_form() {
  const canonicalUrl = 'https://www.internselite.net/Student-Register';
  return (
    <>
    <Helmet>
        <title>Student Registration | InternsElite: Sign Up for Courses and Internships</title>
        <meta name='description' content='Register as a student with InternsElite to sign up for our online courses and internships. Gain access to a wide range of professional training programs, earn certifications, and advance your career. Join our community of learners and start your journey today.' />
        <meta name='keywords' content='student registration, sign up, online courses, internships, professional courses, register now' />
        <meta property="og:title" content="Student Registration | InternsElite: Sign Up for Courses and Internships" />
        <meta property="og:description" content="Register as a student with InternsElite to sign up for our online courses and internships. Gain access to a wide range of professional training programs, earn certifications, and advance your career. Join our community of learners and start your journey today." />
        <meta property="og:url" content="https://internselite.net/Student-Register" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta name="twitter:title" content="Student Registration | InternsElite: Sign Up for Courses and Internships" />
        <meta name="twitter:description" content="Register as a student with InternsElite to sign up for our online courses and internships. Gain access to a wide range of professional training programs, earn certifications, and advance your career. Join our community of learners and start your journey today." />
        <meta name="twitter:image" content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png" />
        <link rel="canonical" href={canonicalUrl} />
    </Helmet>
    {/* ----------------------Desktop View------------------------- */}
    <div className='background py-5 d-none d-md-block'>
      <div className='container pt-5 mt-5'>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-10 shadow px-5 Inner_form_background'>
            <Student_form_content/>
            <Student_Form/>
          </div>
          <div className='col-md-1'></div>
        </div>
      </div>
    </div>

    {/* -------------------Mobile View----------------------- */}
    <div className='background  py-5 mt-3 d-sm-block d-md-none'>
      <div className='container'>
          <div className='shadow px-2 Inner_form_background'>
            <Student_form_content/>
            <Student_Form/>
          </div>
      </div>
    </div>
    </>
  )
}

export default Student_Register_form
